// src/data/memory.ts

/*
      Dias da semana no JavaScript (getDay()):
      0 - Domingo
      1 - Segunda-feira
      2 - Terça-feira
      3 - Quarta-feira
      4 - Quinta-feira
      5 - Sexta-feira
      6 - Sábado
*/
const versionApp: string = "1.3.4"; //Modo dev 1.0.1 ---------------------------
let diaPrimeiro: number = 1;
let segunda: number = 1; //Dia de inscrição ----------------------------
let horaInscricao: number = 13; //Horario da inscricao
let horaResetList: number = 2100;
let limitePresenca: number = 14;
let modoDev: boolean = false; //false ou true --------------------------
let modoDevReset: boolean = false; //Cria uma quartafeira falsa para reset automatico
let isMenuCollapsed: boolean = false;
let isButtonCollapsed: boolean = false;

export const getRawVersionApp = () => {
  return versionApp;
};

export const setMenuCollapsedmemory = (collapsed: boolean) => {
  isMenuCollapsed = collapsed;
};

export const getMenuCollapsedMemory = () => {
  return isMenuCollapsed;
};

export const setButtonCollapsedmemory = (collapsed: boolean) => {
  isButtonCollapsed = collapsed;
};

export const getButtonCollapsedMemory = () => {
  return isButtonCollapsed;
};

export const getModoDev = () => {
  return modoDev;
};
export const getModoDevReset = () => {
  return modoDevReset;
};

export const getVersionApp = () => {
  return modoDev ? "Modo dev" : versionApp;
};

export const getDiaPrimeiro = () => {
  return diaPrimeiro;
};
export const getSegunda = () => {
  return segunda;
};
export const getHorarioInscricao = () => {
  return horaInscricao;
};
export const getHorarioResetList = () => {
  return horaResetList;
};

export const getLimitePresenca = () => {
  return limitePresenca;
};

export const getInicioListaEspera = () => {
  return limitePresenca + 1;
};
